import React, { useEffect } from "react";
import { CKEditor } from "ckeditor4-react";

export function HtmlEditor({
    htmlContent,
    editorRef,
    setEditorRef,
}: {
    htmlContent?: string;
    editorRef: any;
    setEditorRef: (editor: any) => void;
}) {
    const editorConfig = {
        autoParagraph: false,
        allowedContent: true,
        extraPlugins: "bidi, colorbutton, floatpanel, font, imagemaps, justify, panelbutton, showblocks, switchbar",
        toolbar: "Full",
        fullPage: true,
    };
    useEffect(() => {
        if (editorRef && htmlContent) {
            editorRef.setData(htmlContent);
        }
    }, [htmlContent]);
    const instanceReadyHandler = (evt: any) => {
        (window as any).CKFinder.setupCKEditor(evt.editor);
        setEditorRef(evt.editor);
    };
    return <CKEditor onInstanceReady={instanceReadyHandler} config={editorConfig} />;
}
